import React from 'react'
import styled from 'styled-components'
import ErrorImg from '../assets/404Error.png'
import { NavLink } from 'react-router-dom'


const NotFound404 = () => {
  return (
    <Container>
      <img src={ErrorImg} alt="" />
      <NavLink to="/">Go To Home</NavLink>
    </Container>
  )
}

const Container = styled.div`
height:100vh;
width:100vw;
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
img{
  height:20rem;
}
a{
  margin-top:20px;
  padding:10px 20px;
  background-color: #2d69df;
  color: #fff;
  text-decoration: none;
  border-radius:18px;
  &:hover{
    background-color: #124bbb;
  }
}
@media screen and (max-width: 550px) {
  img{
    height:12rem;
  }
  a{
    padding:7px 15px;
    border-radius:18px;
  }
}
@media screen and (max-width: 350px) {
  img{
    height:8rem;
  }
  a{
    padding:7px 15px;
    border-radius:18px;
  }
}
`



export default NotFound404